import axios from "axios";
import * as Sentry from "@sentry/react";
import { triggerLogout, createAbortController } from "@utils/autoLogoutHandler";
import { triggerAppEvent } from "@utils/appEventHandler";
import { getHeaderAttributes } from "./helpers/getHeaderAttributes";

export const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  timeout: 30000,
  withCredentials: true,
});

apiClient.interceptors.request.use((config) => {
  config.headers = {
    ...config.headers,
    ...getHeaderAttributes(),
  };

  const controller = createAbortController();
  config.signal = controller.signal;

  return config;
});

apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.resolve();
    }

    const status = error.response?.status;
    const data = error.response?.data;
    const errorMessages = data?.error || data?.errors || error.message || "Network/server error";

    if (status === 401) {
      triggerLogout();
    } else if (status === 404) {
      triggerAppEvent({ type: "NOT_FOUND", path: "/notFound" });
    } else {
      sentrySendErrors(status, error, data);
    }

    return Promise.reject(new Error(errorMessages));
  }
);

const sentrySendErrors = (status, error, data) => {
  Sentry.captureException(error, {
    extra: { status, url: error.config?.url, responseData: data },
    level: "error",
    tags: { source: "apiClient" },
  });
};
